import ArrowBackIcon from "@mui/icons-material/ArrowBackRounded";
import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import { Button, IconButton } from "@mui/material";
import { useState } from "react";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import useClientContext from "../../../../context/useClientContext";
import { pageRoutes } from "../../../../routes";
import GeneralPageHeader from "../../../common/GeneralPageHeader";
import ApprovalConfigurationContext from "./ApprovalConfigurationContext";
import ApprovalConfigurationTitle from "./ApprovalConfigurationTitle";
import { cancelEditingStepAction, getCreateApprovalConfigurationVersionRequest } from "./approvalConfigurationState";
import DeleteApprovalStepDialog from "./DeleteApprovalStepDialog";

const ApprovalConfigurationPageHeader = () => {
  const { clientCode } = useClientContext();

  const { state, setState, approvalConfiguration, editedStepValidationResults, saveConfiguration } =
    useDefinedContext(ApprovalConfigurationContext);

  const [saving, setSaving] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const handleSave = async () => {
    const payload = getCreateApprovalConfigurationVersionRequest(state, approvalConfiguration);
    if (payload === undefined) {
      return;
    }

    setSaving(true);
    const saved = await saveConfiguration(payload, "Changes saved successfully");
    setSaving(false);

    if (saved) {
      setState({});
    }
  };

  const handleDelete = () => {
    setIsDeleteDialogOpen(true);
  };

  if (state.editedStep !== undefined) {
    return (
      <>
        <GeneralPageHeader
          BackButton={
            <IconButton onClick={() => setState(cancelEditingStepAction())}>
              <ArrowBackIcon />
            </IconButton>
          }
          TitleComponent={
            <ApprovalConfigurationTitle title={state.editedStep.name || "Step"} subtitle="Approval Step" />
          }
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            loading={saving}
            disabled={!state.isEditedStepDirty || !editedStepValidationResults?.isValid}
          >
            Save
          </Button>
          {state.editedStepIndex !== undefined && (
            <ActionsMenuButton
              items={[{ label: "Delete", icon: <DeleteIcon color="error" />, onClick: handleDelete }]}
            />
          )}
        </GeneralPageHeader>
        <DeleteApprovalStepDialog
          approvalStepName={state.editedStep.name}
          open={isDeleteDialogOpen}
          onClose={() => setIsDeleteDialogOpen(false)}
        />
      </>
    );
  }

  return (
    <GeneralPageHeader
      showDefaultBackButtonTo={`/${clientCode}/${pageRoutes.workflows}/${pageRoutes.workflowTemplates}/${approvalConfiguration.workflowTemplateVersionId}`}
      TitleComponent={<ApprovalConfigurationTitle title={approvalConfiguration.workflowName} subtitle="Approval" />}
    />
  );
};

export default ApprovalConfigurationPageHeader;
